<template>
  <div>
    <alert :errors="errors" css_class="ma-1"></alert>
    <list-table
      class="mt-12"
      :itemList="itemList"
      @on-delete="onDelete"
    ></list-table>
  </div>
</template>

<script>
import ListTable from "../../components/question-edits/list-table.vue";
import DateWrapper from "../../logic/common/date-wrapper";
import Alert from "../../components/common/alert.vue";
import AlertBuilder from "../../logic/common/alert-contents";
import Api from "@/logic/api/api.js";
import valueMapper from "../../logic/common/value-mapper";
export default {
  components: {
    "list-table": ListTable,
    alert: Alert,
  },
  computed: {
    itemList() {
      return this.$store.getters.manageQuestionList;
    },
  },
  data() {
    this.$nextTick(() => {
      this.reloadData();
    });
    return {
      errors: [],
    };
  },
  methods: {
    /**
     * アンケートを一覧で取得する
     */
    reloadData() {
      this.$store.commit("setWaiting", true);

      // アンケートを取得する
      Api.call("/question", {})
        .then((result) => {
          this.$store.commit("setWaiting", false);
          //APIから取得した結果を画面に表示する
          const questionList = result.questions;

          this.$store.commit(
              "setManageQuestionList",
              questionList.map((question) => {
                return {
                  recordId: question.id,
                  title: question.title,
                  url: question.url,
                  createdAt: new DateWrapper(
                    question.created_at
                  ).format.build((d) => {
                    // 2000年よりも最近に更新があったのなら日時を返す
                    if (d.date.y >= 2000) {
                      return `${d.date.y}/${d.date.m02}/${d.date.d02}`;
                    }
                    // 2000年以前が最終更新日時であればハイフンを返す
                    return "-";
                  }),
                };
              })
          );
        })
        .catch((result) => {
          this.$store.commit("setWaiting", false);
          Api.resolve(result);
        });
    },
    /**
     * メッセージをクリアする
     */
    clearMessage() {
      this.errors = [];
    },
    /**
     * アンケートを削除する
     */
    onDelete(selected) {
      const deletedMap = {};
      // 送信パラメータを作成する
      const postData = {
        id: selected[0].recordId
      };
      this.clearMessage();
      this.$nextTick(() => {
        // アンケートを削除する
        this.$store.commit("setWaiting", true);
        Api.call("/question/delete", postData)
          .then((result) => {
            this.$store.commit("setWaiting", false);
            const message = valueMapper
              .map({
                success: AlertBuilder.success("削除しました"),
                failed: AlertBuilder.error("削除に失敗しました"),
              })
              .get(result.message);
            if (message) {
              this.errors.push(message);
            }
            if (result.failed) {
              result.failed.forEach((info) => {
                this.errors.push(
                  AlertBuilder.error(
                    `[${deletedMap[info.uid]}]:${info.reason.jp}`
                  )
                );
              });
            }
            this.reloadData();
          })
          .catch((error) => {
            this.$store.commit("setWaiting", false);
            const message = valueMapper
                .map({
                  409: AlertBuilder.error("回答が存在するアンケートは削除できません"),
                })
                .getOrElse(error.status, AlertBuilder.invalid());
            if (message.isInvalid) {
              Api.resolve(error);
            } else {
              this.errors.push(message);
              window.scrollTo(0, 0);
            }
          });
      });
    },
  },
};
</script>

<style></style>
